import { BarChart } from '@/components/charts/bar-chart'
import { customToolTip } from '@/components/charts/utils.ts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import { Engagement } from '../../../types'

interface FanEngagementChartProps {
  engagement: Engagement
}

export const FanEngagementChart = ({ engagement }: FanEngagementChartProps) => {
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Fan Engagement</CardTitle>
      </CardHeader>
      <CardContent className="mx-auto h-96 max-w-xs md:max-w-full">
        <BarChart
          data={{
            labels: ['Fan Engagement'],
            datasets: [
              {
                label: 'Multiple Purchases',
                data: [engagement.subscribedAndMoreThanOnePurchase],
                backgroundColor: ['#1BBFC2'],
              },
              {
                label: 'Minimum one Purchase',
                data: [engagement.subscribedAndOnePurchase],
                backgroundColor: ['#F59AC8'],
              },
              {
                label: 'Minimum one Response',
                data: [engagement.subscribedAndOneMessage],
                backgroundColor: ['#E8157B'],
              },
              {
                label: 'Only Subscribed',
                backgroundColor: ['#8200BE'],
                data: [engagement.onlySubscribed],
              },
            ],
          }}
          options={{
            indexAxis: 'y',
            maintainAspectRatio: false,
            scales: {
              y: {
                grid: {
                  display: false,
                },
              },
            },
            datasets: {
              bar: {
                maxBarThickness: 28,
                borderRadius: 4,
                borderSkipped: false,
                categoryPercentage: 0.8,
              },
            },
            plugins: {
              tooltip: {
                ...customToolTip,
                callbacks: {
                  title: function (context) {
                    return context[0].dataset.label // Sets the dataset label as the tooltip title
                  },
                  label: function (context) {
                    return `${context.parsed.x} Fans` // Sets the data value as the tooltip label
                  },
                },
              },
              legend: {
                display: true,
                align: 'start',
                position: 'top',
                fullSize: true,
              },
            },
          }}
          toggleOptions={{
            hideLabels: true,
          }}
        />
      </CardContent>
    </Card>
  )
}
